import React, { useState } from "react";
import { BsArrowUpShort } from "react-icons/bs";
import { FiCreditCard, FiZap, FiPlus } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { Baseurl } from "../../config/BaseUrl";
import axios from "axios";
import { authActions } from "../../redux/athentication/Athentication";
import { toast } from "react-toastify";
import BossPlans from "./components/BossPlans";

const Wallet = () => {
  const { loginData } = useSelector((store) => store.Athentication);
  const dispatch = useDispatch();
  const [amount, setAmount] = useState("");

  const buyClick = async () => {
    if (!amount || Number(amount) <= 0) {
      toast.warning("Please enter a valid credit amount", {
        position: "top-center",
        autoClose: 1500,
      });
      return;
    }

    try {
      const formdata = {
        mobile: loginData?.mobile,
        creadittoAdd: Number(amount),
      };
      const url = `${Baseurl}/api/v1/user/creaditadd`;
      const fetchData = await axios.put(url, formdata);

      if (fetchData.data && (fetchData.data.success || fetchData.data.user)) {
        const authenticForm = {
          ...fetchData.data.user,
          isAuth: true,
        };
        dispatch(authActions.signIn(authenticForm));
        toast.success(`Successfully added ${amount} credits!`, {
          position: "top-center",
          autoClose: 1500,
        });
        setAmount("");
      }
    } catch (error) {
      toast.error("Unable to add credits. Please try again.");
    }
  };

  return (
    <div className="mgh-wallet-wrapper">
      {/* ================= Top Wallet Cards ================= */}
      <div className="mgh-wallet-cards-grid">
        {/* Card 1: Balance Card */}
        <div className="mgh-wallet-card balance-card">
          <div className="mgh-wallet-card-header">
            <span className="mgh-wallet-card-tag">Account Credits</span>
            <span className="mgh-wallet-role-pill">
              <BsArrowUpShort size={16} />
              {loginData?.role || "Owner"}
            </span>
          </div>

          <div className="mgh-wallet-balance-row">
            <div className="mgh-wallet-balance-texts">
              <span className="mgh-wallet-balance-label">Available Balance</span>
              <h2 className="mgh-wallet-balance-num">
                {loginData?.creadits ?? 0}
                <span className="mgh-wallet-unit">Credits</span>
              </h2>
            </div>
            <div className="mgh-wallet-icon-wrap">
              <img
                src="/assets/images/all/Wallet.png"
                alt="Wallet"
                className="mgh-wallet-img"
              />
            </div>
          </div>
        </div>

        {/* Card 2: Quick Recharge Card */}
        <div className="mgh-wallet-card recharge-card">
          <div className="mgh-wallet-card-header">
            <span className="mgh-wallet-card-tag">Recharge Credits</span>
            <span className="mgh-wallet-help-text">1 Credit = ₹1</span>
          </div>

          <div className="mgh-wallet-recharge-body">
            <div className="mgh-wallet-input-group">
              <span className="mgh-wallet-input-prefix">₹</span>
              <input
                type="text"
                className="mgh-wallet-input"
                placeholder="Enter credit amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value.replace(/\D/g, ""))}
              />
              <button
                type="button"
                className="mgh-wallet-buy-btn"
                onClick={buyClick}
                disabled={!amount || Number(amount) <= 0}
              >
                Add Credits
              </button>
            </div>

            {/* Quick Amount Suggestion Pills */}
            <div className="mgh-wallet-quick-amounts">
              {[100, 500, 1000, 2000].map((quickVal) => (
                <button
                  type="button"
                  key={quickVal}
                  className="mgh-wallet-quick-pill"
                  onClick={() => setAmount(String(quickVal))}
                >
                  +{quickVal}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ================= Embedded BOSS Package Solutions ================= */}
      <BossPlans isEmbedded={true} />
    </div>
  );
};

export default Wallet;
